import { useRouter } from 'next/router';
import { Menu } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';

import useI18n from '@i18n';

import { HeaderNavContext } from '../../interfaces';
import { AUTH_MAIN_NAV_TREE, GUEST_MAIN_NAV_TREE } from '../../config/trees';
import resolveNav from '../../utils/resolveNav';
import mapToAntdMenuItems from '../../utils/mapToAntdMenuItems';
import getActiveKeys from '../../utils/getActiveKeys';

import styles from './index.module.scss';

interface INavBarProps {
    navContext: HeaderNavContext;
}

const NavBar: React.FC<INavBarProps> = ({ navContext }) => {
    const { t } = useI18n('Base');
    const { pathname } = useRouter();
    const tree = navContext.isAuth ? AUTH_MAIN_NAV_TREE : GUEST_MAIN_NAV_TREE;
    const items = resolveNav(tree, navContext, 'navbar', pathname);

    return (
        <nav className={`flex flex-1 items-stretch h-full min-w-0 ${styles.navBar}`}>
            <Menu
                mode="horizontal"
                selectedKeys={getActiveKeys(items)}
                items={mapToAntdMenuItems(items, t)}
                className="flex-1 w-full h-full min-w-0 bg-transparent border-0"
                rootClassName={styles.navBarSubmenuPopup}
                overflowedIndicatorPopupClassName={`${styles.navBarSubmenuPopup} ${styles.navBarMorePopup}`}
                overflowedIndicator={
                    <span id="NavBarDesktopMoreDropdown" className="flex items-center">
                        {t('More')}
                        <FontAwesomeIcon icon={faChevronDown} className="ml-2" />
                    </span>
                }
            />
        </nav>
    );
};

export default NavBar;
